import React, { useEffect, useState, useRef } from "react";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import '../menu.css'
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Skeleton } from "primereact/skeleton";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import * as XLSX from 'xlsx';
import { ProgressSpinner } from "primereact/progressspinner";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import EventEmitter, { Events } from "../../../services/eventemitter";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { t } from "i18next";
import html2canvas from 'html2canvas';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { InputText } from "primereact/inputtext";

const ListAllChatTranscript = () => {
    const tableRef = useRef(null);
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse

    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [selectedTime, setSelectedTime] = useState<any>(null)
    const [timeArray, setTimeArray] = useState<any>([{ displayName: "AM" }, { displayName: "PM" }, { displayName: "ALL" }])
    const [loadingCompanies, setLoadingCompanies] = useState(true)
    const [CompanyArray, setCompanyArray] = useState([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [timeZoneArray, setTimeZoneArray] = useState<any>([])
    const [searchText, setSearchText] = useState("")
    const [tableData, setTableData] = useState<any>([])
    const [expandtableData, setExpandTableData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const CompanyRef = useRef<any>(null);
    const [refreshState, setRefreshState] = useState<any>(new Date())
    const [expandedRows, setExpandedRows] = useState<any>(null);
    const [exportloading, setExportLoading] = useState(false)
    const [hidebutton, setHideButton] = useState(true)
    const [advanceFilter, setAdvanceFilter] = useState("")
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]

    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])

    useEffect(() => {
        ApiCalls()
    }, [])

    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }
    useEffect(() => {
        timeZone()
    }, [selectedWebsite])

    const ApiCalls = async () => {
        loadCompanies()
        timeZone()
        setSelectedTime(timeArray[0])
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any)
        setLoadingCompanies(false)
    };
    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            if (selectedWebsite != null) {
                var data = apiResponse.data.filter(m => m.standardName == selectedWebsite.timeZone)
                if (data.length > 0) {
                    setTimeZoneArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                } else {
                    var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                    setTimeZoneArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                }
            }
            else {
                var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                setTimeZoneArray(apiResponse.data)
                setSelectedTimeZone(data[0])
                setDefaultTime(data[0])
            }
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }

    const onTimeTypeChange = (e) => {
        setSelectedTime(e.value)
    }

    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.companyId,
            websiteId: selectedWebsite?.websiteId,
            timeZone: selectedTimeZone?.standardName,
            timeType: selectedTime?.displayName,
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
            leadType: "",
            chatAdvanceFilter: advanceFilter,
            chatId: ""
        };
    };
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }
    const searchClear = () => {
        setSearchText("")
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }
    const handleSearch = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters };
        _filters1['global'].value = value;
        setFilters(_filters1);
        setSearchText(value)
    }

    const ARTER = async () => {
        var result = await wglcsApiService.AverageResponseTimeandEngagementReport(commonRequestData())
        if (result.data.data != null) {
            var array = [result.data.data]
            setTableData(array)
        } else {
            setTableData([])
        }
        setLoading(false)
    }
    const clearFilter = async () => {

        setAdvanceFilter("")

        setTableData([])

        setLoading(true)

        let body = {

            fromDate: moment(fromDate).format("YYYY-MM-DD"),

            toDate: moment(toDate).format("YYYY-MM-DD"),

            companyId: selectedCompanyName?.companyId,

            websiteId: selectedWebsite?.websiteId,

            timeZone: selectedTimeZone?.standardName,

            timeType: selectedTime?.displayName,

            agentId: 0,

            chatCountBy: "",

            timeFrom: "",

            timeTo: "",

            region: "",

            leadType: "",

            chatAdvanceFilter: "",

            chatId: ""

        }

        var result = await wglcsApiService.getallchattranscriptsexpanded(body)
        if (result.data.data != null) {
            const groupedData = Object.values(result.data.data.reduce((acc, obj) => {
                if (!acc[obj.chatId]) {
                    acc[obj.chatId] = {
                        chatId: obj.chatId.toString(),
                        visitorName: obj.visitorName,
                        chatStartTime: obj.chatStartTime,
                        chatEndTime: obj.chatEndTime,
                        expandedData: []
                    };
                }
                acc[obj.chatId].expandedData.push({
                    messageBy: obj.messageBy,
                    messageText: obj.messageText,
                    time: obj.timeStamp
                });
                return acc;
            }, {}));
            var transformedData = Object.values(groupedData).map(m => {
                (m as any).expandedData.sort((a, b) => {
                    const timeStampA = new Date(a.time).getTime();
                    const timeStampB = new Date(b.time).getTime();
                    return timeStampA - timeStampB;
                });
                return m;
            });
            transformedData.sort((a: any, b: any) => {
                const chatIdA = typeof a.chatId === 'string' ? parseInt(a.chatId) : a.chatId;
                const chatIdB = typeof b.chatId === 'string' ? parseInt(b.chatId) : b.chatId;
                return chatIdB - chatIdA;
            });
            setTableData(transformedData)
        }
        else {

            setTableData([])

        }

        setLoading(false)

    }
    const chattranscriptApi = async () => {

        var result = await wglcsApiService.getallchattranscriptsexpanded(commonRequestData())

        if (result.data.data != null) {

            const groupedData = Object.values(result.data.data.reduce((acc, obj) => {

                if (!acc[obj.chatId]) {

                    acc[obj.chatId] = {

                        chatId: obj.chatId.toString(),

                        visitorName: obj.visitorName,

                        chatStartTime: obj.chatStartTime,

                        chatEndTime: obj.chatEndTime,

                        expandedData: []

                    };

                }

                acc[obj.chatId].expandedData.push({

                    messageBy: obj.messageBy,

                    messageText: obj.messageText,

                    time: obj.timeStamp

                });

                return acc;

            }, {}));

            var transformedData = Object.values(groupedData).map(m => {

                (m as any).expandedData.sort((a, b) => {

                    const timeStampA = new Date(a.time).getTime();

                    const timeStampB = new Date(b.time).getTime();

                    return timeStampA - timeStampB;

                });

                return m;

            });

            transformedData.sort((a: any, b: any) => {

                const chatIdA = typeof a.chatId === 'string' ? parseInt(a.chatId) : a.chatId;

                const chatIdB = typeof b.chatId === 'string' ? parseInt(b.chatId) : b.chatId;

                return chatIdB - chatIdA;

            });

            setTableData(transformedData)

        } else {

            setTableData([])

        }

        setLoading(false)

    }
    const submit = () => {
        if (!selectedCompanyName) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.Company-validation'))
            return;
        }
        else {
            setLoading(true)
            chattranscriptApi()
            setHideButton(false)
        }
    }
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e.value.companyId);
    }

    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
        timeZoneRef?.current.resetFilter();
    }
    const loadWebsites = async (id) => {
        let response = await wglcsApiService.getwebsitebycompanyId(id);
        var data = response.data.data.filter(m => m.status === true)
        setWebsiteArray(data)
        setSelectedWebsite(data[0])
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };
    const renderSearchField = () => {
        return (
            <div className="search-view">
                <input
                    className="searchfeild"
                    value={searchText}
                    onChange={handleSearch}
                    placeholder={t("Search")}
                />
                <i className="fa-light fa-search search-icon"></i>
                {searchText.length > 0 && <i onClick={searchClear} className="fa fa-times clear-icon"></i>}
            </div>
        )
    }
    const ExportPDF = () => {
        setExportLoading(true)
        const tableElement = document.getElementById('table-to-xlsx');
        if (tableElement) {
            var doc = new jsPDF() as any;
            const pdfWidth = doc.internal.pageSize.getWidth();
            const logoWidth = 45;
            const logoHeight = 15;
            const logoY = 5;
            const centerX = (pdfWidth - logoWidth) / 2;
            const imageElement = document.getElementById('logoImage');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            ctx?.drawImage((imageElement as any), 0, 0, canvas.width, canvas.height);
            const imgData = canvas.toDataURL('image/svg');
            doc.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);
            doc.setFontSize(12)
            const text = t('DashboardReports.ListAllChat-Transcripts');
            const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            const textX = (pdfWidth - textWidth) / 2;
            doc.text(text, textX, 30);
            doc.text(55, 38, exportSelectedWebsite())
            const Data = [] as any;
            tableData.forEach(item => {
                Data.push([{ content: 'Visitor Name', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } },
                { content: 'Start Time', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } },
                { content: 'End Time', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } }]);
                Data.push([item.visitorName, startTime_Template(item), endTime_Template(item)]);
                if (item.expandedData.length > 0) {
                    Data.push([{ content: 'Message By', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } },
                    { content: 'Message Text', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } },
                    { content: 'Time', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } }]);
                    item.expandedData.forEach(subItem => {
                        Data.push([subItem.messageBy, subItem.messageText, , TimeStamp_Template(subItem)]);
                    });
                }
            });
            doc.autoTable({
                body: Data,
                bodyStyles: { fontSize: 8, halign: 'center' },
                theme: "grid",
                startY: 45,
            });
            doc.save(`${t('DashboardReports.ListAllChat-Transcripts')}.pdf`);
            setExportLoading(false)
        }
    }

    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };
    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return selectedWebsite?.domainName + " " + "(" + t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY") + ")"
        } else {
            return ""
        }
    }
    const rowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">
                <DataTable value={data.expandedData} responsiveLayout="scroll">
                    <Column field="messageBy" header={t("DashboardReport-dataTable.Message-By")}></Column>
                    <Column field="messageText" header={t("DashboardReport-dataTable.Message-Text")}></Column>
                    <Column field="time" body={TimeStamp_Template} header={t("DashboardReport-dataTable.Time-Stamp")}></Column>
                </DataTable>
            </div>
        );
    }
    const actionTemplate = (rowData) => {
        return (
            <div className="table-icon-container">
                <i className="fa-duotone fa-file-pdf" style={{ color: "red", cursor: "pointer" }}
                    onClick={(e) => sectionPDF(e, rowData)}
                ></i>
            </div>
        )
    }

    const sectionPDF = (e, data) => {
        let array = [data]
        var doc = new jsPDF() as any;
        const pdfWidth = doc.internal.pageSize.getWidth();
        const logoWidth = 45;
        const logoHeight = 15;
        const logoY = 5;
        const centerX = (pdfWidth - logoWidth) / 2;
        const imageElement = document.getElementById('logoImage');
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx?.drawImage((imageElement as any), 0, 0, canvas.width, canvas.height);
        const imgData = canvas.toDataURL('image/svg');
        doc.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);
        doc.setFontSize(12)
        const text = t('DashboardReports.ListAllChat-Transcripts');
        const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const textX = (pdfWidth - textWidth) / 2;
        doc.text(text, textX, 30);
        doc.text(55, 38, exportSelectedWebsite())
        const tableData = [] as any;
        array.forEach(item => {
            tableData.push([{ content: 'Visitor Name', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } },
            { content: 'Start Time', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } },
            { content: 'End Time', styles: { fontSize: 10, fillColor: [78, 134, 199], textColor: 255, fontStyle: 'normal', halign: 'center' } }]);
            tableData.push([item.visitorName, item.chatStartTime, item.chatEndTime]);
            if (item.expandedData.length > 0) {
                tableData.push([{ content: 'Message By', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } },
                { content: 'Message Text', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } },
                { content: 'Time Stamp', styles: { fontSize: 10, fontStyle: 'normal', fillColor: [225, 223, 207], textColor: [0, 0, 0], halign: 'center' } }]);
                item.expandedData.forEach(subItem => {
                    tableData.push([subItem.messageBy, subItem.messageText, TimeStamp_Template(subItem)]);
                });
            }
        });
        doc.autoTable({
            body: tableData,
            bodyStyles: { fontSize: 8, halign: 'center' },
            columnStyles: {
                0: { cellWidth: 40 },
                1: { cellWidth: 100 },
                2: { cellWidth: 45 },
            },
            theme: "grid",
            startY: 45,
        });
        doc.save(`${t('DashboardReports.ListAllChat-Transcripts')}.pdf`);
    }

    const startTime_Template = (rowData) => {
        const dateString = rowData.chatStartTime
        const dateObject = new Date(dateString);

        const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        // Convert hours from 24-hour to 12-hour format
        const hours12 = hours % 12 || 12;
        // Zero padding for single digits
        const formattedMonth = month < 10 ? '0' + month : month;
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedHours = hours12 < 10 ? '0' + hours12 : hours12;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
        const formattedDate = `${formattedMonth}/${formattedDay}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
        return formattedDate

    }

    const endTime_Template = (rowData) => {
        const dateString = rowData.chatEndTime
        const dateObject = new Date(dateString);

        const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        // Convert hours from 24-hour to 12-hour format
        const hours12 = hours % 12 || 12;

        // Zero padding for single digits
        const formattedMonth = month < 10 ? '0' + month : month;
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedHours = hours12 < 10 ? '0' + hours12 : hours12;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
        const formattedDate = `${formattedMonth}/${formattedDay}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
        return formattedDate
    }

    const TimeStamp_Template = (rowData) => {
        const dateString = rowData.time
        const dateObject = new Date(dateString);
        const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        // Convert hours from 24-hour to 12-hour format
        const hours12 = hours % 12 || 12;

        // Zero padding for single digits
        const formattedMonth = month < 10 ? '0' + month : month;
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedHours = hours12 < 10 ? '0' + hours12 : hours12;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
        const formattedDate = `${formattedMonth}/${formattedDay}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
        return formattedDate
    }
    const renderLoader = () => {
        return (
           
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE"  animationDuration=".5s" />
     
        );
    }
    return (
        <> <img id="logoImage" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" style={{ display: 'none' }} />
            <div className="wgReoprts-container">
                <div className="row p-2">
                    <div className="wgreport-tab viewreport-box">
                        <div className="row view-wgreport ">
                            <div className="col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('smtp-DataTable.Company-Name')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="companyName"
                                    value={selectedCompanyName}
                                    options={CompanyArray}
                                    onChange={onCompanyChange}
                                    optionLabel="companyName"
                                    placeholder={!loadingCompanies ? t('fieldsPlaceholder.selectCompany') : selectedCompanyName}
                                // itemTemplate={CompanyOptionTemplate}
                                // ref={CompanyRef}
                                />
                                {loadingCompanies && renderLoader()}
                                </div>
                            </div>
                            <div className="col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="domainName"
                                    value={selectedWebsite}
                                    options={WebsiteArray}
                                    onChange={onWebsiteChange}
                                    optionLabel="domainName"
                                    placeholder={t('ReportComponent.Select Website')} />
                            </div>
                            <div className="col-lg-2 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                                <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                    minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-lg-2 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                                <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                    maxDate={new Date()}
                                    minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                                />
                            </div>

                            <div className="col-lg-2  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="displayName"
                                    value={selectedTimeZone}
                                    options={timeZoneArray}
                                    onChange={onTimeChange}
                                    optionLabel="displayName"
                                    // itemTemplate={TimeTemplate}
                                    placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                                //ref={timeZoneRef}
                                />
                                {timeloading && renderLoader()}
                                </div>
                            </div>

                            <div className="col-lg-3  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t("StaticReport-Text.Time")}</label>
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="displayName"
                                    value={selectedTime}
                                    options={timeArray}
                                    onChange={onTimeTypeChange}
                                    optionLabel="displayName"
                                    itemTemplate={TimeTemplate}
                                    placeholder="Select Time"
                                    ref={timeZoneRef}
                                />
                            </div>

                            <div className="col-lg-3  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t("StaticReport-Text.Advance-Filter")}</label>
                                <InputText className="form-control"
                                    placeholder={t("fieldsPlaceholder.Fist-Name,Last-Name,Phone#,Email")}
                                    value={advanceFilter}
                                    onChange={(e) => setAdvanceFilter(e.target.value)} />
                            </div>

                            <div className="col-lg-6 py-1 text-right text-lg-left">
                                <span className="btn-width wgreport-btn wgbtn" onClick={clearFilter}>{t("StaticReport-Text.Clear-Filter")}</span>
                                {hidebutton == false ? <>
                                    <span title={t('wg-buttons.Export-Excel')}>
                                        <ReactHTMLTableToExcel
                                            id="test-table-xlsx-button search-btn"
                                            className="btn-width wgreport-btn wgbtn p-ripple"
                                            table="table-to-xlsx"
                                            filename={t('DashboardReports.ListAllChat-Transcripts')}
                                            sheet={t('DashboardReports.ListAllChat-Transcripts')}
                                            buttonText={t('wg-buttons.Export-Excel')}
                                        />
                                    </span>   <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                        <ProgressSpinner
                                            style={{ width: "25px", bottom: "10px" }}
                                            strokeWidth="3"
                                            fill="#EEEEEE"
                                            animationDuration=".5s"
                                        /> : t('wg-buttons.Export-PDF')}</button>
                                </> : ""}
                                <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                            </div>
                        </div>


                    </div>
                </div>
            </div >
            <div className="row">
                <div className="col-12 text-center">
                    <div className="wgreport-span">{t('DashboardReports.ListAllChat-Transcripts')}</div>
                    <div className="wgreport-span">{exportSelectedWebsite()}</div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {renderSearchField()}
                </div>
            </div>
            <div id="report">
                <div className="row">
                    <div className="col-12" >
                        {loading == true ?
                            <ProgressSpinner
                                style={{ width: "50px", marginLeft: "50%", marginTop: "10%" }}
                                strokeWidth="3"
                                fill="#EEEEEE"
                                animationDuration=".5s"
                            /> :
                            <DataTable value={tableData}
                                rowExpansionTemplate={rowExpansionTemplate} expandedRows={expandedRows}
                                dataKey="chatId" onRowToggle={(e) => setExpandedRows(e.data)}
                      
                                paginator
                                rows={20}
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                rowsPerPageOptions={[20, 40, 60]}
                                filterDisplay="menu"
                                emptyMessage={t('resourcesPoolTable.Data Not Found')} filters={filters}>
                                <Column className="title" expander style={{ width: '3em' }} header={t("ChatTranscriptComponent.Actions")} />
                                <Column body={actionTemplate} style={{ width: '1em' }}></Column>
                                <Column field="visitorName" style={{ width: '30em' }} header={t("MainComponent.Visitor Name")} sortable></Column>
                                <Column body={startTime_Template} header={t("ChatTranscriptComponent.Start Time")} sortable></Column>
                                <Column body={endTime_Template} header={t("ChatTranscriptComponent.End Time")} sortable></Column>
                            </DataTable>
                        }
                    </div>
                </div>
                <div className='htmltable' style={{ display: 'none' }}>
                    {tableData && <table id="table-to-xlsx" ref={tableRef}>
                        <thead>
                            <tr>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={7}>{t('DashboardReports.ListAllChat-Transcripts')}</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <th style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={7}>{exportSelectedWebsite()}</th>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((item, index) => (
                                <tr key={index}>
                                    <td>&nbsp;</td>
                                    <td style={{ background: "#84bdf3", textAlign: "center", border: "1px solid #000" }} colSpan={2}>{item.visitorName}</td>

                                    <td style={{ background: "#84bdf3", textAlign: "center", border: "1px solid #000" }} colSpan={3}>{t("ChatTranscriptComponent.Start Time")}{startTime_Template(item)}</td>

                                    <td style={{ background: "#84bdf3", textAlign: "center", border: "1px solid #000" }} colSpan={2}>{t("ChatTranscriptComponent.End Time")}{endTime_Template(item)}</td>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <th style={{ background: "#84bdf3", border: "1px solid #000" }} colSpan={2}>
                                            {t("DashboardReport-dataTable.Message-By")}
                                        </th>
                                        <th style={{ background: "#84bdf3", border: "1px solid #000" }} colSpan={4}>
                                            {t("DashboardReport-dataTable.Message-Text")}
                                        </th>
                                        <th style={{ background: "#84bdf3", border: "1px solid #000" }} colSpan={2}>
                                            {t("DashboardReport-dataTable.Time-Stamp")}
                                        </th>
                                    </tr>
                                    {item.expandedData.map(m => (<>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td style={{ textAlign: "center", border: "1px solid #000" }} colSpan={2}>{m.messageBy}</td>
                                            <td style={{ textAlign: "center", border: "1px solid #000" }} colSpan={4}>{m.messageText}</td>
                                            <td style={{ textAlign: "center", border: "1px solid #000" }} colSpan={2}>{TimeStamp_Template(m)}</td>
                                        </tr> </>))}
                                </tr>
                            ))}
                        </tbody>
                    </table>}
                </div>
            </div>
        </>
    )
}
export default ListAllChatTranscript